import { observer } from "mobx-react-lite";
import { useEffect } from "preact/hooks";

import { getApplicationState } from "../../../mobx/State";

import { getClientController } from "../ClientController";

/**
 * Also binds listeners from state to the current client.
 */
const Binder: React.FC = () => {
    const client = getClientController().readyClient;
    useEffect(() => {
        return getApplicationState().registerListeners(client!);
    }, [client]);
    return null;
};

export default observer(Binder);
